module.exports = __webpack_public_path__ + "img/bchusd.ac628d52.png";